import { ArrowPathIcon } from '@heroicons/react/24/outline'
import { ReactElement } from 'react'
import { SectionTitle } from 'app/components/ai-agent-voice-ops/SectionTitle'
import SimpleTable from 'app/components/table/SimpleTable'
import { TableEmptyState } from 'app/components/ui/table-empty-state'
import { DataSourceBadge } from './DataSourceBadge'
import type { UseSmsAgentOpsReturn } from './useSmsAgentOps'

type WorkflowsSectionProps = Pick<UseSmsAgentOpsReturn, `workflowRows` | `workflowColumns`>

/** Which workflows get replies and which drive opt-outs (plan D18). */
export function WorkflowsSection({ workflowRows, workflowColumns }: WorkflowsSectionProps): ReactElement {
  return (
    <div className="mb-8">
      <div className="mb-1">
        <SectionTitle
          title="Workflows"
          badge={`${workflowRows?.length ?? 0} Workflows`}
          adornment={<DataSourceBadge source="preview" />}
        />
      </div>
      <p className="mb-3 text-body-sm text-subtle">
        Texting outcomes per workflow, at the location that runs it. A high opt-out rate means a workflow is wearing
        patients out.
      </p>
      <SimpleTable
        activeSubpage="sms-agent-ops-workflows"
        data={workflowRows}
        columns={workflowColumns}
        initialSort={[{ id: `textsSent`, desc: true }]}
        enableDeepLinking={false}
        hideFooter
        emptyState={
          <TableEmptyState
            icon={<ArrowPathIcon className="h-6 w-6" />}
            title="No workflow texts"
            description="Workflows that sent texts in the date range show up here."
          />
        }
      />
    </div>
  )
}
